export default __webpack_public_path__ + "static/media/allmetalparts.8a287c0c.png";